import { Trans } from 'react-i18next'

import { FormatPrice } from '@reveni-io/reveni-ui'

const InstantStoreCreditText = ({ orderAmount }) => {
  return (
    <>
      <p>
        <Trans
          i18nKey="storeCreditProcessCompletedMessage"
          values={{ amount: orderAmount?.remaining_amount || 0 }}
          defaults="Te hemos enviado por email un código por valor de los <strong><price>{{amount}}</price></strong> de tu reembolso."
          components={{ strong: <strong />, price: <FormatPrice currency={orderAmount?.currency || 'EUR'} /> }}
        />
      </p>
    </>
  )
}

export default InstantStoreCreditText
